import React, { useEffect, useState } from "react";
import "./AdminHome.css";
import { FaCartShopping } from "react-icons/fa6";
import { GiNotebook } from "react-icons/gi";
import { FaUserCircle, FaUserTie } from "react-icons/fa";
import { AiOutlineProduct } from "react-icons/ai";
import { IoMdLogOut } from "react-icons/io";
import UserList from "./UserList";
import AdminStaff from "./AdminStaff";
import AdminQuotation from "./AdminQuotation";
import AdminOrderList from "./AdminOrderList";
import AdminProductList from "./AdminProductList";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MdRateReview } from "react-icons/md";
import { Button, Layout, Menu, ConfigProvider } from "antd";
import AdminViewQuotation from "./AdminViewQuotation";
import { getProfile, getToken } from "../../services/localStorageServices";
import { setUserToken } from "../../features/authSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Exhibition from "./Exhibition";
import Review from "./Review";
import { FaListUl } from "react-icons/fa";
import { SiLibreofficewriter } from "react-icons/si";
import { FaHome } from "react-icons/fa";
import logo from "../../Assets/logo.png";
import Blog from "../AdminPanel/Blog";
import { MdDashboard } from "react-icons/md";
import Dashboard from "./Dashboard";
import { FaClipboardList } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import BlockIpAddress from "./BlockIpAddress";
import AdminHomeDashboard from "./AdminHomeDashboard";
import { MdAnalytics } from "react-icons/md";
import { FaImages } from "react-icons/fa";
import GalleryControl from "./GalleryControl";

const { Header, Sider, Content } = Layout;

const AdminHome = () => {
  const navigate = useNavigate();
  const { access_token } = getToken();
  const { profile } = getProfile();
  const dispatch = useDispatch();
  const [role, setRole] = useState(""); // role will be 'admin' or 'staff'

  const handleLogout = () => {
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("profile");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };

  useEffect(() => {
    dispatch(setUserToken({ token: access_token }));
  }, [access_token, dispatch]);

  useEffect(() => {
    setRole(profile.type);
    if (!profile || profile.type === "user") {
      navigate("/");
    } else if (profile.type === "admin" || profile.type === "staff") {
      navigate("/admin-panel");
    } else {
      navigate("/");
    }
  }, []);

  const [collapsed, setCollapsed] = useState(true);
  const [selectedKey, setSelectedKey] = useState("1");

  const renderMenuItems = () => {
    if (role === "admin") {
      return [
        { key: "1", icon: <MdDashboard />, label: "Dashboard" },
        { key: "2", icon: <UserOutlined />, label: "Users" },
        { key: "3", icon: <GiNotebook />, label: "Create Quotation" },
        { key: "4", icon: <SiLibreofficewriter />, label: "View Quotation" },
        { key: "5", icon: <FaCartShopping />, label: "Orders" },
        { key: "6", icon: <FaUserTie />, label: "Teams" },
        { key: "7", icon: <AiOutlineProduct />, label: "Products List" },
        { key: "8", icon: <FaListUl />, label: "Blog" },
        { key: "9", icon: <FaClipboardList />, label: "Exhibition" },
        { key: "10", icon: <MdRateReview />, label: "Review" },
        { key: "11", icon: <FaLocationDot />, label: "IP Address" },
        { key: "12", icon: <MdAnalytics />, label: "Analytics" },
        { key: "13", icon: <FaImages />, label: "Gallery" },
        {
          key: "14",
          icon: <FaHome />,
          label: "Website",
          onClick: () => navigate("/"),
        },
        {
          key: "15",
          icon: <IoMdLogOut />,
          label: "Log Out",
          onClick: handleLogout,
        },
      ];
    } else if (role === "staff") {
      return [
        { key: "2", icon: <UserOutlined />, label: "Users" },
        { key: "3", icon: <GiNotebook />, label: "Create Quotation" },
        { key: "4", icon: <SiLibreofficewriter />, label: "View Quotation" },
        ...(profile.product_add == "1" ||
        profile.product_price_update == "1" ||
        profile.product_update == "1"
          ? [{ key: "7", icon: <AiOutlineProduct />, label: "Product List" }]
          : []),
        { key: "8", icon: <FaListUl />, label: "Blog" },
        { key: "9", icon: <FaClipboardList />, label: "Exhibition" },
        { key: "10", icon: <MdRateReview />, label: "Review" },
        { key: "13", icon: <FaImages />, label: "Gallery" },

        {
          key: "14",
          icon: <FaHome />,
          label: "Website",
          onClick: () => navigate("/"),
        },
        {
          key: "15",
          icon: <IoMdLogOut />,
          label: "Log Out",
          onClick: handleLogout,
        },
      ];
    }

    return [];
  };

  const renderContent = () => {
    switch (selectedKey) {
      case "1":
        return <AdminHomeDashboard setSelectedKey={setSelectedKey} />;
      case "2":
        return <UserList />;
      case "3":
        return <AdminQuotation />;
      case "4":
        return <AdminViewQuotation />;
      case "5":
        return role === "admin" ? <AdminOrderList /> : null;
      case "6":
        return role === "admin" ? <AdminStaff /> : null;
      case "7":
        return <AdminProductList />;
      case "8":
        return <Blog />;
      case "9":
        return <Exhibition />;
      case "10":
        return <Review />;
      case "11":
        return <BlockIpAddress />;
      case "12":
        return <Dashboard />;
      case "13":
        return <GalleryControl />;
      default:
        return <div>Select a menu item</div>;
    }
  };

  const [isSticky, setIsSticky] = useState(true);

  useEffect(() => {
    // Check screen size and print to console if less than 767 pixels
    if (window.innerWidth <= 767) {
      setIsSticky(false);
    } else {
      setIsSticky(true);
    }
  }, []);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [selectedKey]);

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Layout: {
              /* here is your component tokens */
              zeroTriggerWidth: 0,
            },
          },
        }}
      >
        <Layout>
          <Sider
            collapsed={collapsed}
            collapsible
            className="adminhome-admin-panel-side-bar scrollBarControl"
            trigger={null}
            collapsedWidth={isSticky ? 80 : 0}
            style={{
              minHeight: "100vh",
              position: "fixed",
              top: 0,
              zIndex: 1000,
              marginTop:"50px",
              overflowY:"auto", 
              maxHeight:"100vh",
              paddingBottom:"100px"
            }}
          >
            <h5 className="text-white text-center mt-3">Admin Panel</h5>
            <Menu
              mode="inline"
              defaultSelectedKeys={["1"]} // Set default to 'View Quotation' for staff
              className="adminhome-admin-panel-side-bar"
              selectedKeys={[selectedKey]}
              onClick={(e) => setSelectedKey(e.key)}
              items={renderMenuItems()}
              style={{ minHeight: "100vh", overflowY:"auto" }}
            />
          </Sider>
          <Layout>
            <Header
              style={{
                padding: 0,
                position: "fixed",
                top: 0,
                zIndex: 1000,
                width: "100%",
              }}
              className="adminhome-admin-panel-Header d-flex align-items-center justify-content-between"
            >
              <Button
                type="text"
                className="text-white"
                style={{marginLeft: collapsed ? "20px" : 200}}
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
              />
              <img className="adminHome-header-company-logo" src={logo} />
              <div
                className="adminHome-header-right-div d-flex flex-column align-items-end mx-2"
                style={{ lineHeight: "normal", color: "#fff", gap: "unset" }}
              >
                <h5 style={{ textTransform: "capitalize" }}>
                  <FaUserCircle /> {profile.name}
                </h5>
                <span style={{ textAlign: "left", width: "100%" }}>
                  {profile.type}
                </span>
              </div>
            </Header>
            <Content
              onClick={() => setCollapsed(true)}
              style={{
                padding: window.innerWidth < 768 ? 0 : 24,
                minHeight: 280,
                marginTop:"60px",
                marginLeft: collapsed ? window.innerWidth < 768 ? 0 :80 : 200,
                transition:"0.5 ease-in-out"
              }}
            >
              {renderContent()}
            </Content>
          </Layout>
        </Layout>
      </ConfigProvider>
    </>
  );
};

export default AdminHome;
